import React from 'react';
import '../App.css'; // Ensure this file contains the loader CSS

const Loader = () => {
  return (
    <section className="loader-container" role="status" aria-live="polite" aria-busy="true">
      <p className="visually-hidden">Loading…</p>
      <ul className="loader" role="list" aria-label="Loading animation">
        <li className="crystal" role="presentation" aria-hidden="true"></li>
        <li className="crystal" role="presentation" aria-hidden="true"></li>
        <li className="crystal" role="presentation" aria-hidden="true"></li>
        <li className="crystal" role="presentation" aria-hidden="true"></li>
        <li className="crystal" role="presentation" aria-hidden="true"></li>
        <li className="crystal" role="presentation" aria-hidden="true"></li>
      </ul>
    </section>
  );
};

export default Loader;